module.exports = __webpack_public_path__ + "static/img/pinpai-5.61d9cf9d.png";